import React from 'react';
import { motion } from 'framer-motion';
export function GuaranteeSection() {
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-57">
      {/* Brillo de fondo específico para resaltar el oro */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-yellow-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-58" />

      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-block relative max-w-3xl mx-auto" data-id="element-60">
          {/* Contenedor tipo Tarjeta Premium */}
          <div className="relative bg-gradient-to-b from-[#121212] to-black border border-yellow-500/30 p-10 md:p-14 rounded-[2.5rem] shadow-[0_0_60px_-15px_rgba(234,179,8,0.2)]" data-id="element-61">
            
            {/* Imagen del Sello 3D */}
            <div className="w-40 h-40 md:w-56 md:h-56 mx-auto mb-8 relative" data-id="element-62">
               {/* Resplandor detrás del sello */}
               <div className="absolute inset-0 bg-yellow-400 blur-3xl opacity-20 animate-pulse" data-id="element-63"></div>
               
               {/* TU NUEVO SELLO 3D GENERADO */}
               <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/Gemini_Generated_Image_hoi84zhoi84zhoi8.jpg?v=1770659983" alt="Garantía de Satisfacción 100%" className="w-full h-full object-contain relative z-10 drop-shadow-2xl transform hover:scale-105 transition-transform duration-500 rounded-full" data-id="element-64" />
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-65">
              GARANTÍA BLINDADA DE <span className="text-yellow-400" data-id="element-66">7 DÍAS</span>
            </h2>

            <div className="space-y-4 text-gray-300 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-67">
              <p data-id="element-68">
                No queremos tu dinero si no estás saltando de alegría con los resultados.
              </p>
              <p data-id="element-69">
                Descarga el pack, usa los prompts y prueba las herramientas. Si en 7 días no sientes que has <span className="text-white font-bold" data-id="element-70">ahorrado al menos 10 horas de trabajo</span>, envíanos un simple correo.
              </p>
              <p className="text-white font-medium" data-id="element-71">
                Te devolveremos el 100% de tu inversión en 24 horas.
              </p>
              
              <div className="pt-6 mt-6 border-t border-white/10" data-id="element-72">
                <p className="font-bold text-yellow-500 text-sm tracking-[0.2em] uppercase" data-id="element-73">
                  SIN RIESGO • SIN PREGUNTAS • SIN LETRA PEQUEÑA
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}